import List from "src/dataTypes/lists/List";
import NumberList from "src/dataTypes/numeric/NumberList";
import { typeOf } from "src/tools/utils/code/ClassUtils";

StringList.prototype = new List();
StringList.prototype.constructor = StringList;

/**
 * @classdesc {@link List} for storing Strings.
 *
 * Additional functions that work on StringList can be found in:
 * <ul>
 *  <li>Operators:   {@link StringListOperators}</li>
 *  <li>Conversions: {@link StringListConversions}</li>
 * </ul>
 *
 * @constructor
 * @description Creates a new StringList
 *
 * @category strings
 */
function StringList() {
  var args = [];

  for(var i = 0; i < arguments.length; i++) {
    args[i] = String(arguments[i]);
  }
  var array = List.apply(this, args);
  array = StringList.fromArray(array);
  
  return array;
}
export default StringList;

/**
 * @todo write docs
 */
StringList.fromArray = function(array, forceToString) {
  forceToString = forceToString == null ? true : forceToString;

  var result = List.fromArray(array);
  if(forceToString) {
    for(var i = 0; i < result.length; i++) {
      result[i] = String(result[i]);
    }
  }
  result.type = "StringList";

  //assign methods to array:
  result.getLengths = StringList.prototype.getLengths;
  result.includesSubString = StringList.prototype.includesSubString;
  result.indexesOfSubString = StringList.prototype.indexesOfSubString;
  result.toLowerCase = StringList.prototype.toLowerCase;
  result.toUpperCase = StringList.prototype.toUpperCase;
  result.append = StringList.prototype.append;
  result.getSurrounded = StringList.prototype.getSurrounded;
  result.replace = StringList.prototype.replace;
  result.getConcatenated = StringList.prototype.getConcatenated;
  result.trim = StringList.prototype.trim;

  //override
  result.clone = StringList.prototype.clone;

  return result;
};

/**
 * overrides List.prototype.getLengths (see comments there)
 */
StringList.prototype.getLengths = function() {
  var lengths = new NumberList();

  this.forEach(function(string) {
    lengths.push(string == null ? 0 : string.length);
  });

  return lengths;
};


/**
 * detects wheter the stringList contains a sub-string in any of its eleeents
 *
 * @param  {String} substring to search
 * @return {Boolean}
 * tags:search
 */
StringList.prototype.includesSubString = function(substring) {
  for(var i=0; i<this.length; i++){
    if(this[i].includes(substring)) return true;
  }
  return false;
};

/**
 * find positions where the stringList contains a sub-string in any of its eleeents
 *
 * @param  {String} substring to search
 * @return {NumberList}
 * tags:search
 */
StringList.prototype.indexesOfSubString = function(substring){
    var indexes = new mo.NumberList();
    for(var i=0; i<this.length; i++){
        if(this[i].includes(substring)) indexes.push(i);
    }
    return indexes;
};


/**
 * @todo write docs
 */
StringList.prototype.append = function(sufix, after) {
  after = after == null ? true : after;
  var newStringList = new StringList();
  newStringList.name = this.name;
  var sufixIsStringList = typeOf(sufix) == "StringList";
  var i;
  if(after) {
    for(i = 0; this[i] != null; i++) {
      newStringList[i] = this[i] + (sufixIsStringList ? sufix[i] : sufix);
    }
  } else {
    for(i = 0; this[i] != null; i++) {
      newStringList[i] = (sufixIsStringList ? sufix[i] : sufix) + this[i];
    }
  }
  return newStringList;
};

/**
 * prefix and sufix can be string or a StringList
 */
StringList.prototype.getSurrounded = function(prefix, sufix) {//to be deprecated
  sufix = sufix==null?"":sufix;
  
  var newStringList = new StringList();
  newStringList.name = this.name;
  var i;

  var prefixIsStringList = Array.isArray(prefix);
  var sufixIsStringList = Array.isArray(sufix);

  for(i = 0; this[i] != null; i++) {
    newStringList[i] = (prefixIsStringList ? prefix[i] : prefix) + this[i] + (sufixIsStringList ? sufix[i] : sufix);
  }

  return newStringList;
};


//deprectaed, replaced by replaceInStrings
/**
 * @ignore
 */
StringList.prototype.replace = function(regExp, string) {
  if(regExp==null) return this;

  var newStringList = new StringList();
  var i;
  var l = this.length;

  newStringList.name = this.name;

  for(i = 0; i<l; i++){
    newStringList[i] = this[i].replace(regExp, string);
  }

  return newStringList;
};

/**
 * returns a String with all the strings concatenated
 *
 * @param  {String} separator to place between Strings (default: a space)
 * @return {String}
 * tags:combine
 */
StringList.prototype.getConcatenated = function(separator) {
  separator = separator == null ? ' ' : separator;
  var i;
  var string = "";
  var l = this.length;
  for(i = 0; i<l; i++) {
    string += this[i];
    if(i < this.length - 1) string += separator;
  }
  return string;
};

/**
 * applies toLowercase to all strings
 * @return {StringList}
 * tags:transform
 */
StringList.prototype.toLowerCase = function() {
  var newStringList = new StringList();
  newStringList.name = this.name;
  var i;
  var l = this.length;
  for(i = 0; i<l; i++) {
    newStringList[i] = this[i].toLowerCase();
  }
  return newStringList;
};

/**
 * applies toUpperCase to all strings
 * @return {StringList}
 * tags:transform
 */
StringList.prototype.toUpperCase = function() {
  var newStringList = new StringList();
  newStringList.name = this.name;
  var i;
  var l = this.length;
  for(i = 0; i<l; i++) {
    newStringList[i] = this[i].toUpperCase();
  }
  return newStringList;
};

/**
 * trims all the strings on the stringList. Can also be a Table in which case all the StringLists inside it get trimmed
 *
 * @param {Number} maxLength if defined then the left most characters up to the maximum are taken
 * @return {StringList}
 * tags:transform,clean
 */
StringList.prototype.trim = function(maxLength) {
  if(this.isTable) return this.trim();
  if(this.type != 'StringList') return null;
  var i;
  var l = this.length;
  var newStringList = new StringList();
  for(i = 0; i<l; i++) {
    newStringList[i] = maxLength ? this[i].substring(0,maxLength).trim() : this[i].trim();
  }
  newStringList.name = this.name;
  return newStringList;
};

///////overriding

/**
 * @todo write docs
 */
StringList.prototype.clone = function() {
  var newList = StringList.fromArray(this.slice(), false);
  newList.name = this.name;
  if(this.fnDerived)
    newList.fnDerived = this.fnDerived;
  return newList;
};
